import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { DPProduct } from './model/dp-product';
import { DPSubscriptionService } from './dp-subscriptions.service';
import { DPAccountService } from './dp-accounts.service';
import { DPAccount } from './dp-account';
import { DPSubscriptionRequest } from './model/dp-subscriptionRequest';
import { DPModule } from './model/dp-module';
import { DPModuleConfig } from './model/dp-module-config';

import { Router } from '@angular/router';
import { NotificationsService, SimpleNotificationsComponent } from 'angular2-notifications';
import { ToasterService } from 'angular2-toaster/src/toaster.service';


@Component({
    selector: 'my-module-detail',
    templateUrl: 'dp-module-detail.component.html'
})
export class DPModuleDetailComponent implements OnInit {
    @Input() account_module: DPModule;
    @Output() close = new EventEmitter();
    dpmodules: DPModule[];

    errorResponse: any;
    navigated = true; // true if navigated here
    success: any;
    resModule: DPModule;
    account_id: number;
    subscription_id: number;
    notificationTitle: any;
    notificationContent: any;
    notificationType: any;
    enableValue = false;
    submitting = false;
    enableConfig = false;
    configValues: DPModuleConfig[];
    subcriptionTypeSpec = 'carryover';
    subscriptionType = 'Monthly (Carry Over)';
    asd: any;

    constructor(
        private toasterService: ToasterService,

        private router: Router,
        private _service: NotificationsService,
        private subscriptionService: DPSubscriptionService,
        private route: ActivatedRoute) {
    }
    public options = {
        timeOut: 5000,
        lastOnBottom: true,
        clickToClose: true,
        maxLength: 0,
        maxStack: 7,
        showProgressBar: true,
        pauseOnHover: true,
        preventDuplicates: false,
        preventLastDuplicates: 'visible',
        rtl: false,
        animate: 'scale',
        position: ['right', 'bottom']
    };


    createNotification() {
        switch (this.notificationType) {
            case 'success':
                //this._service.success(this.notificationTitle, this.notificationContent);
                this.toasterService.pop('success', this.notificationTitle, this.notificationContent);
                break;
            case 'error':
                this.toasterService.pop('error', this.notificationTitle, this.notificationContent);
                //this._service.error(this.notificationTitle, this.notificationContent);
                break;
            case 'info':
                this.toasterService.pop('info', this.notificationTitle, this.notificationContent);
                //this._service.info(this.notificationTitle, this.notificationContent);
                break;
        }
    }

    errorHandler(error: any) {
        this.submitting = false;
        this.notificationType = 'error';
        this.notificationTitle = 'Error';
        if (error.status == 400) {
            this.notificationContent = 'The value must be integer between 1 and 2500';

        } else {
            const jsonErrorBody = JSON.parse(error._body);
            this.notificationContent = jsonErrorBody.error.message;
        }
        this.createNotification();
    }

    getModuleDetail(account_id: number, subscriptionId: number) {
        return this.subscriptionService
            .getSubscriptions(account_id)
            .then(res => {
                this.dpmodules = res.subscriptions.modules;
                this.account_module = this.dpmodules.find(u => u.product.product_offering_id == subscriptionId);
                if (this.account_module.product.product_offering_id == 1 || this.account_module.product.product_offering_id == 4 || this.account_module.product.product_offering_id == 2) {
                    this.enableConfig = true;
                    if (this.account_module.product.product_offering_id == 1) {
                        if (this.account_module.configs.find(x => x.specification_name == 'consultanttype').specification_value == 'noncarryover') {
                            this.subscriptionType = 'Monthly (Non Carry Over)';
                            this.subcriptionTypeSpec = 'noncarryover';
                        } else if (this.account_module.configs.find(x => x.specification_name == 'consultanttype').specification_value == 'yearly') {
                            this.subscriptionType = 'Yearly';
                            this.subcriptionTypeSpec = 'yearly';
                        }
                    }
                }
                this.configValues = this.account_module.configs;
            })
            .catch(error => this.errorHandler(error));
    }


    ngOnInit() {
        this.route.params.forEach((params: Params) => {
            const subscriptionId = +params['subscriptionId'];
            const accountId = +params['accountId'];
            this.account_id = accountId;
            this.subscription_id = subscriptionId;
            this.getModuleDetail(accountId, subscriptionId);
        });
    }

    save1(rmodule: DPModule, isValid: boolean) {
        if (isValid == true) {

            this.submitting = true;
            rmodule.subscription_id = this.subscription_id;
            rmodule.configs = this.configValues;
            rmodule.product_id = this.account_module.product.product_offering_id;

            if (rmodule.product_id == 1) {
                rmodule.configs.find(x => x.specification_name == 'consultanttype').specification_value = this.subcriptionTypeSpec;
            }
            this.save(rmodule);
        }
    }

    save(rmodule: DPModule) {
        this.subscriptionService
            .updateModule(rmodule, this.account_id, this.subscription_id)
            .then(user => {
                this.goBack();
            })
            .catch(error => this.errorHandler(error));
    }


    goBack() {
        if (this.navigated) {
            event.stopPropagation();
            this.router.navigate(['/demandportal/customer/account/subscriptions', this.account_id]);

        }
    }

    setConfigValues(module: DPModuleConfig, value: string) {
        this.configValues.forEach(c => {
            if (c == module) {
                c.specification_value = value;
            }
        });
    }

    setConfigSwitch(module: DPModuleConfig) {
        this.configValues.forEach(c => {
            if (c == module) {
                if (c.specification_value == 'true') {
                    c.specification_value = 'false';
                } else {
                    c.specification_value = 'true';

                }
            }
        });
    }


    clickViewType(event: any) {
        if (this.subscriptionType == 'Monthly (Carry Over)') {
            this.subcriptionTypeSpec = 'carryover';
        } else if (this.subscriptionType == 'Monthly (Non Carry Over)') {
            this.subcriptionTypeSpec = 'noncarryover';
        } else if (this.subscriptionType == 'Yearly') {
            this.subcriptionTypeSpec = 'yearly';
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/portalv1/dp-module-detail.component.ts